import { useSelector } from "react-redux";
import { ScreenType, useHomeContext } from "../../contexts/HomeContextProvider";
import styles from "./index.module.scss";
import { parseHTML } from "../../utils";

const StartScreen = () => {
  const { updateScreen, state } = useHomeContext();
  const { appData } = state;
  const user = useSelector((state) => state.user);

  const handleCTA = () => {
    updateScreen(user ? ScreenType.TEMPLATE_SCREEN : ScreenType.FORM_SCREEN);
  };
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <img
          className={styles.logo}
          src={require("../../assets/images/brandLogoDesktop.png")}
          alt="Docflix"
        />
        {parseHTML(appData?.currentEventData?.startScreen?.titleMobile)}
        <img
          className={styles.heart}
          src={require("../../assets/images/heartdayLogo.png")}
        />
      </div>
      <div className={styles.right}>
        {parseHTML(appData?.currentEventData?.startScreen?.title)}
        {parseHTML(appData?.currentEventData?.startScreen?.description)}
        {appData?.currentEventData?.startScreen?.title && <button className={`btn ${styles.myBtn}`} onClick={handleCTA}>
          {user ? "DASHBOARD" : "TRY NOW"}
        </button>}
      </div>
    </div>
  );
};

export default StartScreen;
